import {Box,Grid,Button,Paper,InputBase,MenuItem,Breadcrumbs,Link,Typography,Menu} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useItemDeadStockReportList } from "api/hooks/reports";
import { useSelector } from "react-redux";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ItemDeadStockReportPdf from "scenes/reports/pdfForms/inventory/deadStockReportPdf";
import { currencyFormatter } from "utilities/currencyFormatter";

export default function DeadStockReport() {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const user = useSelector((state) => state.authReducer.user);
  const {itemDeadStockReportList, isLoadingItemDeadStockReportList, setSearch} = useItemDeadStockReportList(1, business_branch_id);

  const [openExportOptions, setOpenExportOptions] = useState(false);
  const [anchorE1, setAnchorE1] = useState(null);

  const handleClickOpen = (event) => {
    setAnchorE1(event.currentTarget);
    setOpenExportOptions(true);
  };

  const handleClose = () => {
    setOpenExportOptions(false);
  };
  const [searchContent, setSearchContent] = useState("");

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value);
  };

  const handleClickSearch = async () => {
    setSearch(searchContent);
  };

  const columns = [
    { label: "Item", width: 275 },
    { label: "Description", width: 275 },
    { label: "Purchase Date" },
    { label: "Dead Stock Date" },
    { label: "Current Stock", align: "center" },
    { label: "Batch", align: "center" },
    { label: "Expiry Date" },
    { label: "Unit" },
    { label: "Cost Price" },
    { label: "Supplier" },
  ];

  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Item Dead Stock Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={4}>
              <Paper
                sx={{
                  my: "4px",
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  minWidth: 170,
                  maxWidth: 300,
                }}
              >
                <InputBase
                  placeholder="Search Item Name"
                  value={searchContent}
                  onChange={handleSearchInput}
                  sx={{ ml: 1, flex: 1 }}
                />
                <IconButton onClick={handleClickSearch}>
                  <SearchIcon />
                </IconButton>
              </Paper>
            </Grid>

            <Grid xs={4}>
              
            </Grid>
            <Grid xs={2} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                anchorE1={anchorE1}
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
              <Menu
                style={{ marginRight: "30px" }}
                anchorEl={anchorE1}
                open={openExportOptions}
                onClose={handleClose}
              >
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  <PDFDownloadLink document={<ItemDeadStockReportPdf viewData={{ report_detail: itemDeadStockReportList,}}  printedBy={user.first_name + ' ' + user.last_name}/>} fileName={`Item Dead Stock Report`}>
                    PDF
                  </PDFDownloadLink>
                </MenuItem>    
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  EXCEL
                </MenuItem>  
              </Menu>
            </Grid>
          </Grid>
        </Box>

        <ReportTable
          columns={columns}
          rows={itemDeadStockReportList}
          loading={isLoadingItemDeadStockReportList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id ?? index} index={index}>
              <RCell>{row.related_product.product_name}</RCell>
              <RCell>{row.related_product.description}</RCell>
              <RCell>{moment(row.related_product_purchase.purchase_date).format("L")}</RCell>
              <RCell>{moment(row.dead_stock_date).format("L")}</RCell>
              <RCell align="center">{row.remaining_quantity}</RCell>
              <RCell align="center">{row.batch}</RCell>
              <RCell>{moment(row.related_product_purchase.expiry_date).format("L")}</RCell>
              <RCell>{row.related_product_unit.related_business_product_unit.name}</RCell>
              <RCell>{currencyFormatter(parseFloat(Number(row.smallest_unit_unit_cost) * Number(row.remaining_quantity)))}</RCell>
              <RCell>{row.related_product_purchase.related_supplier.name}</RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
